import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { comicCategories } from '@/mocks/comics';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <span className="text-2xl font-bold font-heading text-primary-600">
              汗汗漫画
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === '/'
                  ? 'text-primary-600 bg-primary-100/80'
                  : 'text-foreground-700 hover:text-primary-600 hover:bg-background-100'
              }`}
            >
              首页
            </Link>
            <div className="relative group">
              <button className="px-4 py-2 rounded-lg text-sm font-medium text-foreground-700 hover:text-primary-600 hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer flex items-center gap-1">
                漫画分类
                <i className="ri-arrow-down-s-line text-xs"></i>
              </button>
              <div className="absolute top-full left-0 mt-1 w-48 bg-background-50 rounded-xl shadow-lg border border-background-200/70 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 py-2">
                {comicCategories.map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="flex items-center gap-3 px-4 py-2.5 text-sm text-foreground-700 hover:text-primary-600 hover:bg-background-100 transition-colors whitespace-nowrap"
                  >
                    <span className="w-5 h-5 flex items-center justify-center">
                      <i className={`${cat.icon} text-sm`}></i>
                    </span>
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>
            <Link
              to="/about"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === '/about'
                  ? 'text-primary-600 bg-primary-100/80'
                  : 'text-foreground-700 hover:text-primary-600 hover:bg-background-100'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <a
              href="#"
              className="px-5 py-2 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              onClick={(e) => {
                e.preventDefault();
              }}
            >
              虫虫漫画入口
            </a>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg hover:bg-background-100 transition-colors cursor-pointer"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="菜单"
          >
            <i className={`ri-${mobileMenuOpen ? 'close' : 'menu'}-line text-xl text-foreground-800`}></i>
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 animate-in slide-in-from-top-2 duration-200">
          <div className="px-4 py-3 space-y-1">
            <Link
              to="/"
              className="block px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:text-primary-600 hover:bg-background-100 transition-colors"
            >
              首页
            </Link>
            <div className="text-sm font-medium text-foreground-500 px-4 py-2">漫画分类</div>
            {comicCategories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="flex items-center gap-3 px-4 py-3 rounded-lg text-sm text-foreground-700 hover:text-primary-600 hover:bg-background-100 transition-colors"
              >
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className={`${cat.icon} text-sm`}></i>
                </span>
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className="block px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:text-primary-600 hover:bg-background-100 transition-colors"
            >
              关于我们
            </Link>
            <div className="pt-2 pb-1">
              <a
                href="#"
                className="block text-center px-5 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                onClick={(e) => e.preventDefault()}
              >
                虫虫漫画入口
              </a>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}